import { Tile, NUM_TILE_TYPES } from './tiles';

/** 길이 34 카운트 배열. index = 타일 종류, 값 = 장수. */
export type TileCounts = number[];

export function toCounts(tiles: readonly Tile[]): TileCounts {
  const counts = new Array(NUM_TILE_TYPES).fill(0);
  for (const t of tiles) counts[t]++;
  return counts;
}

export function countsToTiles(counts: TileCounts): Tile[] {
  const tiles: Tile[] = [];
  for (let t = 0; t < NUM_TILE_TYPES; t++) {
    for (let i = 0; i < counts[t]; i++) tiles.push(t);
  }
  return tiles;
}

export function cloneCounts(counts: TileCounts): TileCounts {
  return counts.slice();
}

export function totalCount(counts: TileCounts): number {
  let sum = 0;
  for (const c of counts) sum += c;
  return sum;
}
